var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.026,
    height: 34.502,
    viewBox: "0 0 47.026 34.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "high-high-linear-gradient",
    x1: 0.935,
    y1: 0.744,
    x2: 0.04,
    y2: 0.749,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64f884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1fce7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High_Guage",
    "data-name": "High Guage",
    transform: "translate(-910.983 -507.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727",
    transform: "translate(122.176 -0.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_39",
    "data-name": "Union 39",
    d: "M41.867,22a18.191,18.191,0,0,0-3.725-10.476l3.225-2.54A22.215,22.215,0,0,1,46,22ZM0,22A22.2,22.2,0,0,1,5.471,7.966l3.143,2.628A18.212,18.212,0,0,0,4.135,22ZM23.994,4.078V.021A23.141,23.141,0,0,1,40.781,8.257L37.561,10.8A18.976,18.976,0,0,0,23.994,4.078Zm-17.9,3.2A23.18,23.18,0,0,1,23,0h.051V4.052H23A19,19,0,0,0,9.24,9.906Z",
    transform: "translate(789.32 508.712)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#high-high-linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2728",
    "data-name": "Group 2728",
    transform: "matrix(0.309, 0.951, -0.951, 0.309, 1099.211, -91.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_605",
    "data-name": "Polygon 605",
    d: "M1,0,2,24H0Z",
    transform: "translate(539 328)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_671",
    "data-name": "Ellipse 671",
    transform: "translate(539 347)",
    fill: "#fff",
    stroke: "#2e2e2e",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.875,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "HIGH",
    transform: "translate(925 540)",
    fill: "#2e2e2e",
    fontSize: 8,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HIGH")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighGauge);
export default __webpack_public_path__ + "static/media/high-gauge.4a6504bde0a4dae37953278990571516.svg";
export { ForwardRef as ReactComponent };